import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL,
  ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL,
  ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL,
  ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL,
  ONLINE_STORE_CLOSE_SYNCING_PRODUCT_DONE_MODAL,
  ONLINE_STORE_CLOSE_SYNCING_PRODUCT_IN_SYNC_MODAL,
  ONLINE_STORE_CLOSE_SYNCING_PRODUCT_RESULT_MODAL,
  ONLINE_STORE_SHOW_SYNCING_PRODUCT_DONE_MODAL,
  ONLINE_STORE_SHOW_SYNCING_PRODUCT_IN_SYNC_MODAL,
  ONLINE_STORE_SHOW_SYNCING_PRODUCT_RESULT_MODAL,
  ONLINE_STORE_START_SYNCING_PRODUCT_VALIDATION_FLOW,
} from 'actions/onlineStore/constants';

const showSyncProductEmptyProductModal = createReducer(false, {
  [ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_PRODUCT_MODAL]: () => false,
});

const showSyncProductEmptySyncedModal = createReducer(false, {
  [ONLINE_STORE_SHOW_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_SYNCING_PRODUCT_EMPTY_SYNCED_MODAL]: () => false,
});

const showSyncingProductInSyncModal = createReducer(false, {
  [ONLINE_STORE_SHOW_SYNCING_PRODUCT_IN_SYNC_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_SYNCING_PRODUCT_IN_SYNC_MODAL]: () => false,
});

const showSyncingProductResultModal = createReducer(false, {
  [ONLINE_STORE_SHOW_SYNCING_PRODUCT_RESULT_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_SYNCING_PRODUCT_RESULT_MODAL]: () => false,
});

const showSyncingProductDoneModal = createReducer(false, {
  [ONLINE_STORE_SHOW_SYNCING_PRODUCT_DONE_MODAL]: () => true,
  [ONLINE_STORE_CLOSE_SYNCING_PRODUCT_DONE_MODAL]: () => false,
});

const selectedShopId = createReducer(null, {
  [ONLINE_STORE_START_SYNCING_PRODUCT_VALIDATION_FLOW]: (draft, { payload }) =>
    payload.shopId,
});

export default combineReducers({
  selectedShopId,
  showSyncProductEmptyProductModal,
  showSyncProductEmptySyncedModal,
  showSyncingProductInSyncModal,
  showSyncingProductResultModal,
  showSyncingProductDoneModal,
});
